import { Form, notification } from "antd"
import { useWatch } from "antd/es/form/Form"
import { useAddFeatureFeedbackMutation, useLazyGetFeatureFeedbackOptionsQuery } from "features/shared/api"
import { t } from "i18next"
import { forwardRef } from "react"
import theme from "utils/themeVars"
import { Modal, SelectInput, TextInput } from ".."

const AiFeedbackForm = forwardRef(({ entity, entityId, setDislikeColor = () => {}, from }, ref) => {
  const [form] = Form.useForm()
  const [getFeedbackOptions, { data: feedbackOptions, isFetching: fetchingFeedbackOptions }] =
    useLazyGetFeatureFeedbackOptionsQuery()
  const [addFeedback, { isLoading }] = useAddFeatureFeedbackMutation()

  const feedbackOption = useWatch("feedbackOptionId", form)

  const onModalVisible = () => {
    entity === "management_meeting"
      ? getFeedbackOptions({ entity: "management_meeting" }, true)
      : getFeedbackOptions({}, true)
  }
  const resetForm = () => {
    ref.current.setVisible(false)
    form.resetFields()
  }
  const handleSubmit = values => {
    let payload = {
      ...values,
      entity: entity,
      entityId: entityId,
      ...(entity === "management_meeting" && from !== "meetingAIDrawer" && { rating: 1 }),
    }
    addFeedback(payload)
      .unwrap()
      .then(() => {
        notification.success({ message: t("Feedback has been submitted successfully") })
        resetForm()
      })
      .catch(e => {
        notification.error({ message: e.message })
      })
  }
  const otherOptionId = feedbackOptions?.find(item => item?.key === "other")?.id

  return (
    <Modal
      title={t("Feedback")}
      ref={ref}
      okText={t("Save")}
      cancelText={t("Cancel")}
      onOk={form.submit}
      onCancel={() => {
        resetForm()
        setDislikeColor(theme["text-color-secondary"])
      }}
      onModalVisible={onModalVisible}
      loading={isLoading}
      destroyOnClose
    >
      <div style={{ minHeight: 350 }}>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name={"feedbackOptionId"}
            label={t("Issue")}
            required
            rules={[
              {
                validator: (_, value) => {
                  return !value ? Promise.reject(t("Issue selection is required")) : Promise.resolve()
                },
              },
            ]}
          >
            <SelectInput
              allowClear
              options={feedbackOptions}
              inputLoading={fetchingFeedbackOptions}
              placeholder={t("Select an issue")}
            />
          </Form.Item>
          <Form.Item
            name={"comment"}
            label={t("Comment")}
            required={
              entity !== "management_meeting" || (entity === "management_meeting" && feedbackOption == otherOptionId)
            }
            rules={[
              {
                validator: (_, value) => {
                  if (entity === "management_meeting") {
                    return !value && feedbackOption == otherOptionId
                      ? Promise.reject(t("Comment is required"))
                      : Promise.resolve()
                  } else {
                    return !value ? Promise.reject(t("Comment is required")) : Promise.resolve()
                  }
                },
              },
            ]}
          >
            <TextInput lineCount={3} placeholder={t("Add Comment")} />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  )
})

export default AiFeedbackForm
